export { default } from './data/en.json'
